import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "14px",
  height: "14px",
  viewBox: "0 0 12 12",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"Mes-Students\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"Mes-students---Popin2\" transform=\"translate(-362.000000, -462.000000)\" fill=\"#353B5B\" fill-rule=\"nonzero\"><g id=\"Popin\"><g id=\"Block/Students/Profile\" transform=\"translate(319.000000, 27.000000)\"><g id=\"Second\" transform=\"translate(43.000000, 345.000000)\"><g id=\"Définis\" transform=\"translate(0.000000, 88.000000)\"><g id=\"Icon/Profile/Me\" transform=\"translate(0.000000, 2.000000)\"><path d=\"M6,0 C2.7,0 0,2.7 0,6 C0,9.3 2.7,12 6,12 C9.3,12 12,9.3 12,6 C12,2.7 9.3,0 6,0 Z M6,2.25 C6.825,2.25 7.5,2.925 7.5,3.75 C7.5,4.575 6.825,5.25 6,5.25 C5.175,5.25 4.5,4.575 4.5,3.75 C4.5,2.925 5.175,2.25 6,2.25 Z M8.25,8.25 L3.75,8.25 L3.75,6.75 L8.25,6.75 L8.25,8.25 Z\"></path></g></g></g></g></g></g></g>", 1)
  ]))]))
}
export default { render: render }